import { render } from "./datapegawai.vue?vue&type=template&id=9c88c6fe"
import script from "./datapegawai.vue?vue&type=script&lang=js"
export * from "./datapegawai.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__